<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <h2 class="hl-variation-list">
          {{ $t("Menu.var.jewellery.necklace") }}
        </h2>
        <ul class="default-option-list" v-if="possibleItems.listType == 1">
          <li
            v-for="(item, index) in possibleItems.list"
            v-bind:key="index"
            @click="changeItem(item.itemnumber, item.alerts)"
            :class="{ match: item.match }"
            class="pointer"
          >
            <div class="crop-img">
              <img
                :src="
                  getApiHost +
                  '/v2/images/item/f7f5f3/600/600/' +
                  item.itemnumber[0].toUpperCase() +
                  '.jpg'
                "
                :alt="item.itemnumber[0].toUpperCase()"
              />
            </div>
            <p>
              {{ item.text }}
            </p>
          </li>
        </ul>
        <ul v-if="possibleItems.listType == 2">
          <li v-for="(disc, discId) in possibleItems.list" v-bind:key="discId">
            <h5 v-if="$t('Menu.list.titles.stones.' + discId) != ''">
              {{ $t("Menu.list.titles.stones." + discId) }}
            </h5>
            <h5 v-else>{{ $t("Menu.list.titles.discs") }} {{ discId + 1 }}</h5>
            <ul>
              <li v-for="(item, index) in disc" v-bind:key="index">
                <a
                  @click="changeItem(item.itemnumber)"
                  :class="{ match: item.match }"
                >
                  <template v-if="discId == 'common' && index == 'empty'">
                    {{ $t("Menu.list.stones.basicModel.empty") }}
                  </template>
                  <template v-else-if="discId == 'common' && index == 'stone'">
                    {{ $t("Menu.list.stones.basicModel.stone") }}
                  </template>
                  <template v-else>
                    {{ item.text }}
                  </template>
                </a>
              </li>
              <li v-if="discId == 'common'">
                <a @click="configure('stones/library')">
                  {{ $t("Menu.list.titles.stones.library") }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/vuex/Config";

export default {
  name: "VariationsNecklace",
  props: ["possibleItems"],
  data() {
    return {
      getApiHost: Config.getters.getApiHost,
      appUrl: Config.getters.getAppUrl,
    };
  },
  methods: {
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  div.crop-img {
    width: 7.5rem;
    height: 7.5rem;
  }
}
</style>
